import { IChat } from "../../../../interface/Chat";

export const updateConversationAiAgentStatus = (conversations: IChat[], chat: IChat) => {

  return conversations.map(convo => {
    if(convo._id === chat._id) return chat
    return convo
  })

}